import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Link } from 'gatsby';

import Layout from '../layout';

import LeftArrow from '../../icons/LeftArrow';
import RightArrow from '../../icons/RightArrow';
import AdultFooter from '../../icons/AdultFooter';

import Audio from '../Audio';
import Sharing from '../Sharing';

import internalPageStyle from './internalPage.module.css';

const InternalPage = (props) => {
  return (
    <Layout>
      <main className={internalPageStyle.container}>
        <Helmet>
          <title>{props.name}</title>
        </Helmet>

        <header className={internalPageStyle.header}>
          <Link className={internalPageStyle.navLink} to='/'>
            <LeftArrow />

            На главную
          </Link>

          {props.next && (
            <Link className={internalPageStyle.navLink} to={props.next}>
              Далее

              <RightArrow />
            </Link>
          )}
        </header>

        <div className={internalPageStyle.nameWrapper}>
          <h1 className={internalPageStyle.name}>{props.name}</h1>
          <p className={internalPageStyle.bio}>{props.bio}</p>

          <div className={internalPageStyle.sharingContiner}>
            <Sharing light />
          </div>
        </div>

        {props.children}

        <Audio src={props.audio} title={props.name} duration={props.audioDuration} />

        <footer className={internalPageStyle.footer}>
          <AdultFooter />
        </footer>
      </main>
    </Layout>
  );
}

InternalPage.propTypes = {
  name: PropTypes.string,
  next: PropTypes.string,
  audio: PropTypes.string,
  audioDuration: PropTypes.number,
  bio: PropTypes.string,
  children:  PropTypes.node,
}

InternalPage.defaultProps = {
  name: '',
  next: '',
  audio: '',
  audioDuration: 0,
  bio: '',
  children:  null,
}

export default InternalPage;
